import { v4 as uuid } from 'uuid';
import { getSignInAuth, getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function signUpAndInWithEmail(email, profile) {
    try {
        const username = email.toLowerCase();
        await getSignUpAuth().signUp({
            username,
            password: uuid(),
            attributes: {
                ...profile,
                'custom:provider:name': 'unclaimed',
                email: username,
            },
        });
        await getSignInAuth().signIn(username);
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
